import { get, post } from '../axios'

// 弃单召回邮件配置查询
export function recall_cart2_config_query_get(map, option) {
  return get(
    `${process.env.VUE_APP_RECALL}/recall/cart2/config/query`,
    map,
    option
  ).then(response => response)
}

// 修改弃单召回邮件配置
export function recall_cart2_config_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_RECALL}/recall/cart2/config/update`,
    map,
    option
  ).then(response => response)
}

// 邮件发送列表查询
export function recall_cart2_email_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_RECALL}/recall/cart2/email/list`,
    map,
    option
  ).then(response => response)
}

// 邮件重新发送
export function recall_cart2_email_resend_id_post(map, option) {
  return post(
    `${process.env.VUE_APP_RECALL}/recall/cart2/email/resend/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 手动调用（测试用）
export function recall_cart2_manual_get(map, option) {
  return get(
    `${process.env.VUE_APP_RECALL}/recall/cart2/manual`,
    map,
    option
  ).then(response => response)
}
